<template>
  <div class="superAdmin notranslate">
    <h1 class="boxTitle mb15 toCapitalize">뷰어 관리자</h1>
    <div class="listBox">
      <div class="listTitle">
        <p>로컬스토리지</p>
        <button type="button" class="btnFold" :class="{isFold: !localStorageView}" @click="localStorageView = !localStorageView"></button>
        <button v-if="localStorage" type="button" class="btn btnRed sizeS" @click="delLocalStorage('all')">전체삭제</button>
      </div>
      <div v-if="localStorage && localStorage.length">
        <ul v-show="localStorageView" class="list">
          <li v-for="(item, index) in localStorage"
            :key="index"
            class="item">
            <span class="title">
              {{item.name}}
              {{ item.key === 'cart' 
                ? item.data.catCode && item.data.catCode.includes('amenity')
                  ? '(amenity)'
                  : `(${item.data.title})`
                : '' }}
            </span>
            <button type="button" class="btn" @click="delLocalStorage(item.id)">삭제</button>
          </li>
        </ul>
      </div>
      <div v-else class="noData">현재 저장된 데이터가 없습니다.</div>
    </div>
    <div class="listBox">
      <div class="listTitle">
        <p>저장 페이지</p>
        <button type="button" class="btnFold" :class="{isFold: !indexedDbView}" @click="indexedDbView = !indexedDbView"></button>
        <button v-if="indexedDb" type="button" class="btn btnRed sizeS" @click="delIndexedDb('all')">전체삭제</button>
      </div>
      <div v-if="getIndexedDbSize" class="sizeState">
        저장소 사용량: {{`${getIndexedDbSize.percentageUsed}%`}} (사용: {{ byteToMb(getIndexedDbSize.usage) }}/전체: {{ byteToMb(getIndexedDbSize.quota) }})
      </div>
      <div v-if="indexedDb && indexedDb.length">
        <ul v-show="indexedDbView" class="list">
          <li
            v-for="(item, index) in indexedDb"
            :key="index"
            class="item">
            <span class="stkr" :class="item.content_type">{{ getContentTypeName(item.content_type) }}</span>
            <span class="version">ver: {{ item.version }}</span>
            <span class="title">{{ item.title }}</span>
            <span class="date">{{ getDateFormat(item.updateat) }}</span>
            <button type="button" class="btn" @click="delIndexedDb(item.id)">삭제</button>
          </li>
        </ul>
      </div>
      <div v-else class="noData">현재 저장된 데이터가 없습니다.</div>
    </div>
    <div class="btns">
      <button type="button" class="btn" @click="goMain">메인으로 이동</button>
    </div>
  </div>
</template>

<script>
import moment from 'moment/moment'
import regExp from '@/common/regExp'

export default {
  name: 'SuperAdmin',
  props: [
  ],
  computed: {
    getIndexedDbSize () {
      return this.$store.getters['versionhistory/getIndexedDbStorage']
    }
  },
  created () {
    this.init()
  },
  mounted () {
  },
  data () {
    return {
      localStorageView: true,
      indexedDbView: true,
      localStorage: null,
      indexedDb: null
    }
  },
  methods: {
    init () {
      const isLogin = this.$store.getters['authentication/isLogin']
      if (!isLogin) {
        this.$router.push({
          name: 'login'
        })
      } else {
        this.$store.dispatch('versionhistory/checkIndexedDbStorage')
        this.getIndexedDb()
        this.getLocalStorage()
      }
      this.$store.dispatch('versionhistory/checkIndexedDbStorage')
      this.getIndexedDb()
      this.getLocalStorage()
    },
    goMain () {
      this.$router.push({
        name: 'main'
      })
    },
    getIndexedDb () {
      const site = this.$store.state.authentication.site
      const idxedDB = window.indexedDB
      this.indexedDb = null
      if (idxedDB) {
            return new Promise ((resolve, reject) => {
                const request = idxedDB.open(`${site}_store`)
                request.onerror = (e) => {
                    reject(e)
                }
                request.onsuccess = (e) => {
                    const db = request.result
                    const transaction = db.transaction('gvf')
                    transaction.onerror = (e) => reject(e)
                    const objStore = transaction.objectStore('gvf')
                    const objStoreRequest = objStore.getAll()
                    objStoreRequest.onsuccess = (e) => {
                      const result = objStoreRequest.result && objStoreRequest.result.length ? objStoreRequest.result : null
                      this.indexedDb = result
                      ? result.map(x => {
                          return {
                            id: x.id,
                            content_type: x.content_type,
                            title: x.data && x.data.title,
                            updateat: x.updateat,
                            version: x.version
                          }
                        }).sort((a, b) => {
                          return a.content_type < b.content_type ? -1 : a.content_type > b.content_type ? 1 : 0
                        })
                      : null
                    }
                }
            })
        }
    },
    async delIndexedDb (id) {
      const confirmMessage = id && id !== 'all' ? '이 저장 페이지를 삭제하시겠습니까?' : '저장된 모든 페이지를 삭제하시겠습니까?'
      if (window.confirm(confirmMessage)) {
        await this.$store.dispatch('versionhistory/deleteIndexedDb', id)
        this.getIndexedDb()
        alert('삭제되었습니다.')
      }
    },
    byteToMb (byte) {
      let str = ''
      if (byte >= 1024 * 1024) {
        byte = byte / (1024 * 1024)
        byte = byte.toFixed(5)
      }
      str = regExp.comma(byte) + 'mb'
      return str
    },
    getLocalStorage () {
      const site = this.$store.state.authentication.site
      const keys = [
        {index: 0, key1: 'cart', key2: site, name: '장바구니 상품'},
        {index: 1, key1: 'layerpopup', key2: site, name: '레이어팝업 닫기 정보'},
        {index: 2, key1: 'order', name: '비정상 종료된 결제 정보'},
        {index: 3, key1: 'product_zoom', key2: site, name: '상품 리스트 글자 크기 정보'},
        {index: 4, key1: 'place', key2: site, name: '상품 픽업 장소 정보'},
        {index: 5, key1: 'bookmarkChannel', name: '북마크된 TV 채널'},
        {index: 6, key1: 'tvIndex', name: '선택된 TV 인덱스'},
        {index: 7, key1: 'voice', key2: site, name: '스마트보이스 언어 정보'}
      ]
      let data = []
      function hasItem (storageKey, key1, key2) {
        const hasKey1 = key1 && storageKey.includes(key1)
        const hasKey2 = key2 ? storageKey.includes(key2) : true
        return hasKey1 && hasKey2
      }
      function parseJson (str) {
        return JSON.parse(str)
      }
      this.localStorage = null
      if (localStorage.length > 0) {
        for (let i = 0; i < localStorage.length; i++) {
          const storage = localStorage.key(i)
          for (let j = 0; j < keys.length; j++) {
            const key = keys[j]
            const key1 = key.key1
            const key2 = key.key2
            if (hasItem(storage, key1, key2)) {
              data.push({
                index: key.index,
                id: storage,
                key: key.key1,
                name: key.name,
                data: parseJson(localStorage.getItem(storage))
              })
            }
          }
        }
        data = data.sort((a, b) => {
          return a.index > b.index ? 1 : a.index < b.index ? -1 : 0
        })
        this.localStorage = data && data.length ? data : null
      }
    },
    delLocalStorage (key) {
      const confirmMessage = key && key !== 'all' ? '이 정보를 삭제하시겠습니까?' : '모든 정보를 삭제하시겠습니까?'
      if (window.confirm(confirmMessage)) {
        if (key !== 'all') {
          localStorage.removeItem(key)
        } else {
          localStorage.clear()
        }
        this.getLocalStorage()
        alert('삭제되었습니다.')
      }
    },
    getContentTypeName (contentType) {
      switch (contentType) {
        case 'page':
          return '페이지'
          break
        case 'product':
          return '상품'
          break
      }
    },
    getDateFormat (isoString) {
      return isoString ? moment(isoString).locale('ko').format('YYYY-MM-DD(ddd) HH:mm:ss') : '-'
    }
  }
}
</script>

<style lang="scss" scoped>
.superAdmin {
  padding: 30px 30px 60px;
  .btn {
    min-width: 0;
    border-radius: 4px;
  }
}
.listBox {
  padding: 30px;
  border: 1px solid $color-lgrey2;
  border-radius: 12px;
  & + .listBox {
    margin-top: 30px;
  }
  .noData {
    margin: 30px 0;
    text-align: center;
    color: $color-grey;
  }
}
.listTitle {
  display: flex;
  align-items: center;
  .btnFold {
    position: relative;
    width: 30px;
    height: 30px;
    margin-left: 8px;
    border: 1px solid $color-lgrey2;
    border-radius: 4px;
    &:after {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      width: 6px;
      height: 6px;
      margin-top: -4px;
      margin-left: -4px;
      border-bottom: 1px solid $color-lgrey;
      border-right: 1px solid $color-lgrey;
      transform-origin: 50%;
      transform: rotate(45deg);
      transition: all 0.3s;
    }
    &.isFold:after {
      margin-top: -2px;
      transform: rotate(-135deg);
    }
  }
  p {
    font-size: 20px;
    font-weight: bold;
  }
  .btn {
    margin-left: auto;
  }
}
.sizeState {
  font-size: 12px;
  color: $color-lgrey;
}
.bar {
  position: relative;
  height: 8px;
  border-radius: 8px;
  overflow: hidden;
  background-color: $bg-default;
  .active {
    height: 100%;
    background-color: $color-green;
  }
}
.list {
  margin-top: 15px;
}
.item {
  position: relative;
  padding: 15px;
  border-radius: 8px;
  background-color: $bg-default;
  & + .item {
    margin-top: 15px;
  }
  .stkr {
    display: inline-block;
    width: 42px;
    margin-bottom: 4px;
    padding: 2px 0;
    text-align: center;
    font-size: 12px;
    color: $color-white;
    border-radius: 4px;
    background-color: $color-dark;
    &.product {
      background-color: $color-green;
    }
  }
  .btn {
    position: absolute;
    top: 15px;
    right: 15px;
    padding: 0.2em 15px;
    font-size: 14px;
  }
  .title {
    display: block;
  }
  .version {
    margin-left: 8px;
    font-size: 12px;
  }
  .date {
    margin-right: 8px;
    font-size: 12px;
    white-space: nowrap;
  }
}
@media screen and (min-width: 768px) {
  .item {
    display: flex;
    align-items: center;
    padding: 4px 4px 4px 12px;
    font-size: 14px;
    & + .item {
      margin-top: 4px;
    }
    .btn {
      position: static;
      padding: 0.6em 25px;
    }
    .stkr {
      width: 42px;
      margin-bottom: 0;
      margin-right: 8px;
    }
    .title {
      flex: 1;
    }
    .version {
      padding-right: 8px;
      margin-left: 0;
      margin-right: 8px;
      border-right: 1px solid $color-lgrey2;
    }
    .date {
      padding-left: 8px;
      margin-left: auto;
      margin-right: 16px;
    }
  }
}
.btns {
  margin-top: 30px;
}
</style>
